class AnimeOnAir {
    constructor(init) {
        this.spec = init.spec;
        this.time = parseDate(init.time);
    }
}
class AnimeName {
    constructor(init) {
        this.japanese = init.japanese;
        this.chinese = init.chinese;
    }
}
class AnimeImage {
    constructor(init) {
        this.url = init.url;
        this.thumbnailUrl = init.thumbnailUrl;
    }
    getThumbnailUrl() {
        if (this.thumbnailUrl) {
            return this.thumbnailUrl;
        }
        const size = this.url.length;
        const index = size - 4;
        return this.url.slice(0, index) + "-300x300" + this.url.slice(index);
    }
}
class AnimeCasting {
    constructor(init) {
        this.character = init.character;
        this.voiceActor = init.voiceActor;
    }
}
class AnimeStaff {
    constructor(init) {
        this.role = init.role;
        this.name = init.name;
    }
}
class Anime {
    constructor(init, year, month) {
        this.id = init.id;
        this.year = year;
        this.month = month;
        this.name = init.name !== undefined ? new AnimeName(init.name) : undefined;
        this.onAir = init.onAir !== undefined ? new AnimeOnAir(init.onAir) : undefined;
        this.images = init.images !== undefined ? init.images.map(v => new AnimeImage(v)) : undefined;
        this.story = init.story;
        this.copyright = init.copyright;
        this.castings = init.castings !== undefined ? init.castings.map(v => new AnimeCasting(v)) : undefined;
        this.staffs = init.staffs !== undefined ? init.staffs.map(v => new AnimeStaff(v)) : undefined;
    }
}
function parseDate(str) {
    if (str !== undefined && str !== null) {
        return new Date(str);
    }
    return undefined;
}
export { Anime };
